/* global gapi */
import React from "react";
import {Redirect} from "react-router-dom";
import {
  Loader,
  Icon,
  Form,
  Dimmer,
  Checkbox,
  Grid,
  Container,
  Menu,
  Header,
  Segment,
  List,
  Message,
  Card,
  Button,
  Image
} from "semantic-ui-react";
import showdown from "showdown";
import rp from "request-promise";
import qs from "qs";

// import FullCalendar from 'fullcalendar-reactwrapper';
import FullCalendar from "@fullcalendar/react";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import momentTimezonePlugin from "@fullcalendar/moment-timezone"; // https://fullcalendar.io/docs/timeZone
import "@fullcalendar/core/main.css";
import "@fullcalendar/daygrid/main.css";
import "@fullcalendar/timegrid/main.css";
import moment from "moment";
import Nav from "./nav.jsx";
import TIMEZONES from './util/timezones.json';
import axios from 'axios';
import firebase from 'firebase';
import { SpinnerRomb } from 'spinners-react';

// Get our global state object
import { StateContext } from './state.jsx';

const photonConfig = (process.env.NODE_ENV === 'production') ? require('../config.json').photon.production : require('../config.json').photon.development;


/*!
 * Group items from an array together by some criteria or value.
 * (c) 2019 Tom Bremmer (https://tbremer.com/) and Chris Ferdinandi (https://gomakethings.com), MIT License,
 * @param  {Array}           arr      The array to group items from
 * @param  {String|Function} criteria The criteria to group by
 * @return {Object}                   The grouped object
 */
var groupBy = function (arr, criteria) {
  return arr.reduce(function (obj, item) {

    // Check if the criteria is a function to run on the item or a property of it
    var key = typeof criteria === 'function' ? criteria(item) : item[criteria];

    // If the key doesn't exist yet, create it
    if (!obj.hasOwnProperty(key)) {
      obj[key] = [];
    }

    // Push the value to the object
    obj[key].push(item);

    // Return the object to the next item in the loop
    return obj;

  }, {});
};


class Calendar extends React.Component{
  static contextType = StateContext;
  static defaultProps = {}

  state = {
    redirect:false,
    selectedWindows: [],
    formattedAvailability: "",
    flashClipboard: false,
    flashClearButton: false,
    currentTimezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    events: [],
    accounts: [],
    isLoadingAccounts: true,
    isLoadingEvents: true,
    calendarList: [],
    calendarMap: {},

    FORM_ACCESSREQUEST_recipientEmail: '',
    FORM_ACCESSREQUEST_loading: false,
    FORM_ACCESSREQUEST_successMessage: null,
    FORM_ACCESSREQUEST_errorMessage: null,
  }

  addOutlookEvents = (events) => {
    console.log('Retrieved calendar events...');
    console.log(events);

    let transformedEvents = this.state.events.slice(0);

    if (events.length > 0) {
      for (var i = 0; i < events.length; i++) {
        var event = events[i];

        // TODO come back and deal wiht all day events
        let start = '';
        let end = '';

        if (event.isAllDay) {
          start = event.start.dateTime;
          end = event.end.dateTime;
        } else  {
          start = moment.tz(event.start.dateTime, event.start.timeZone).format()
          end = moment.tz(event.end.dateTime, event.end.timeZone).format()
        }

        transformedEvents.push({
          id: event.id,
          allDay: event.isAllDay,
          title: event.subject,
          start: start,
          end: end,
          color: 'rgb(179, 225, 247)',
          textColor: 'rgba(32, 33, 36, 0.5)',
          borderColor: 'rgb(129, 205, 242)'
        });
      }
      this.setState({
        events: transformedEvents,
        isLoadingEvents: false
      })
    } else {
      console.log('No upcoming events found.');
    }
  }
  addGoogleEvents = (events) => {
    console.log('Retrieved calendar events...');
    console.log(events);

    let transformedEvents = this.state.events.slice(0);

    if (events.length > 0) {
      for (var i = 0; i < events.length; i++) {
        var event = events[i];
        var start = event.start.dateTime;
        if (!start) {
          start = event.start.date;
        }
        var end = event.end.dateTime;
        if (!end) {
          end = event.end.date;
        }

        transformedEvents.push({
          id: event.id,
          title: event.summary,
          start: start,
          end: end,
          color: 'rgb(179, 225, 247)',
          textColor: 'rgba(32, 33, 36, 0.5)',
          borderColor: 'rgb(129, 205, 242)'
        });
      }
      console.log(transformedEvents)
      this.setState({
        events: transformedEvents,
        isLoadingEvents: false
      })
    } else {
      console.log('No upcoming events found.');
    }

  }

  componentDidUpdate(prevProps, prevState) {
    Object.entries(this.props).forEach(([key, val]) =>
      prevProps[key] !== val && console.log(`Cal Prop '${key}' changed`)
    );
    if (this.state) {
      Object.entries(this.state).forEach(([key, val]) =>
        prevState[key] !== val && console.log(`Cal State '${key}' changed`)
      );
    }
  }

  componentDidMount = () => {
    const [{firebaseUserIdToken, firebaseUser, calendarMap}, dispatch] = this.context;
    this.refreshAccounts().then((accounts) => {

      if (!accounts){
        return;
      }

      if (accounts.length === 0){dispatch({type: 'toggleIsLoading'})}

      accounts.forEach((account, index) => {
        if (account.provider == 'GOOGLE') {
          let refreshToken = account.refreshToken;

          this.retrieveAndStructureEventsForCalendar(account.refreshToken, account.provider, 'primary').then(parsedEvents => {

            let newCalendarMap = calendarMap;
            newCalendarMap[account.owner.email] = {
              id: account.owner.email,
              summary: account.owner.email,
              accountId: account.id,
              refreshToken: account.refreshToken,
              provider: account.provider,
              events: parsedEvents,
              visible: account.isOwner,
              account: account,
              isOwner: account.isOwner
            }

            // Update global state
            dispatch({
              type: 'updateCalendarMap',
              newCalendarMap: newCalendarMap
            })
            if (index === accounts.length-1){
              dispatch({
                type: 'toggleIsLoading'
              })
            }

          }).catch(error => {
            console.log(error);
          });

        } else if (account.provider == 'MICROSOFT') {

          console.log(account)

          this.retrieveAndStructureEventsForCalendar(account.refreshToken, account.provider, 'Microsoft').then(parsedEvents => {

            let newCalendarMap = calendarMap;
            newCalendarMap[account.owner.email] = {
              id: account.owner.email,
              summary: account.owner.email,
              accountId: account.id,
              refreshToken: account.refreshToken,
              provider: account.provider,
              events: parsedEvents,
              visible: account.isOwner,
              account: account,
              isOwner: account.isOwner
            }

            // Update global state
            dispatch({
              type: 'updateCalendarMap',
              newCalendarMap: newCalendarMap
            })
            if (index === accounts.length-1){
              dispatch({
                type: 'toggleIsLoading'
              })
            }

          }).catch(error => {
            console.log(error);
          });

        }
      });
    });
  }

  refreshAccounts = async () => {
    console.log('refreshing accounts v2!')
    const [{firebaseUserIdToken, firebaseUser}, dispatch] = this.context;

    let accounts = await axios({
      method: 'get',
      url: `${photonConfig.functionsURL}accounts`,
      headers: { Authorization: `Bearer ${firebaseUserIdToken}` }
    })
    .then(result => {
      return result.data;
    })
    .catch(error => {
      console.log(error);
    });
    console.log('accounts', accounts);
    return accounts;
  }

  addNewAccountWithAuthCode = (authorizationCode, provider) => {
    const [{ firebaseUser, firebaseUserIdToken }, dispatch] = this.context;

    this.setState({isLoadingAccounts: true});
    let userUid = firebaseUser.uid;

    axios({
      'method': 'post',
      'url': `${photonConfig.functionsURL}token`,
      'headers': {'Content-Type':'application/x-www-form-urlencoded', 'Authorization': `Bearer ${firebaseUserIdToken}`},
      'data': qs.stringify({
        'code': authorizationCode,
        'userUid': userUid,
        'tenant': 'common',
        'provider': provider
      })
    })
    .then(result => {
      console.log(result.data);
      this.refreshAccounts();
    }).catch(err => {
      console.log(err)
      this.setState({isLoadingAccounts: false});
    })

  }

  handleRemoveAccount = (documentId, e) => {
    const [{ firebaseUser }, dispatch] = this.context;
    let userUid = firebaseUser.uid;
    this.props.firebaseDatabase.collection(`/accounts/${userUid}/linkedAccounts`).doc(documentId).delete().then(() => {
      console.log("Document successfully deleted!");
      this.refreshAccounts();
    }).catch(function(error) {
        console.error("Error removing document: ", error);
    });
  }

  listAllCalendars(refreshToken) {
    const [{ firebaseUserIdToken}, dispatch] = this.context;
    // axios({
    //   method: 'get',
    //   url: '${photonConfig.functionsURL}accessRequest',
    //   headers: { Authorization: `Bearer ${firebaseUserIdToken}` }
    // })
    // .then(result => {
    //   dispatch({
    //     type: 'updateAccessRequests',
    //     newAccessRequests: result.data
    //   });
    //   this.setState({isLoading: false});
    // })
    // .catch(error => {
    //   console.log(error);
    //   this.setState({isLoading: false});
    // });

    var options = {
      'method': 'POST',
      'url': `${photonConfig.functionsURL}listGoogleCalendars`,
      'headers': {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Authorization': `Bearer ${firebaseUserIdToken}`
      },
      form: {
        'tenant': 'common',
        'refreshToken': refreshToken
      },
      json: true
    };
    return rp(options);
  }

  retrieveAndStructureEventsForCalendar = async (refreshToken, provider, calendarId) => {

    const [{ firebaseUserIdToken}, dispatch] = this.context;
    let firebaseFunction = (provider === 'MICROSOFT') ? 'listMicrosoftEvents' : 'listGoogleEvents';

    let eventsForCalendar = await axios({
      method: 'post',
      url: `${photonConfig.functionsURL}${firebaseFunction}`,
      headers: { Authorization: `Bearer ${firebaseUserIdToken}` },
      data: {
        'tenant': 'common',
        'refreshToken': refreshToken,
        'calendarId': calendarId
      }
    })
    .then(result => {
      if (provider === 'MICROSOFT') {

        let events = result.data.value;

        let transformedEvents = [];

        if (events.length > 0) {
          for (var i = 0; i < events.length; i++) {
            var event = events[i];

            // TODO come back and deal wiht all day events
            let start = '';
            let end = '';

            if (event.isAllDay) {
              start = event.start.dateTime;
              end = event.end.dateTime;
            } else  {
              start = moment.tz(event.start.dateTime, event.start.timeZone).format()
              end = moment.tz(event.end.dateTime, event.end.timeZone).format()
            }

            transformedEvents.push({
              id: event.id,
              allDay: event.isAllDay,
              title: event.subject,
              start: start,
              end: end,
              color: 'rgb(179, 225, 247)',
              textColor: 'rgba(32, 33, 36, 0.5)',
              borderColor: 'rgb(129, 205, 242)'
            });
          }
        } else {
          console.log('No upcoming events found.');
        }
        return transformedEvents;

      } else if (provider === 'GOOGLE') {

        let events = result.data;
        console.log('Retrieved google events...', events);

        let transformedEvents = [];

        if (events.length > 0) {
          for (var i = 0; i < events.length; i++) {
            var event = events[i];
            var start = event.start.dateTime;
            if (!start) {
              start = event.start.date;
            }
            var end = event.end.dateTime;
            if (!end) {
              end = event.end.date;
            }

            transformedEvents.push({
              id: event.id,
              title: event.summary,
              start: start,
              end: end,
              color: 'rgb(179, 225, 247)',
              textColor: 'rgba(32, 33, 36, 0.5)',
              borderColor: 'rgb(129, 205, 242)'
            });
          }
        } else {
          console.log('No upcoming events found.');
        }
        return transformedEvents;
      }


    })
    .catch(error => {
      console.log(error);
      return [];
    });


    console.log(eventsForCalendar);

    return eventsForCalendar;

  }

  updateTimezone = (zone) => {
    let newRawAvailability = this.getRawAvailability(this.state.selectedWindows, zone);
    this.setState({
      currentTimezone: zone,
      rawAvailability: newRawAvailability,
      markdownAvailability: this.getMarkdownFormattedAvailability(newRawAvailability),
      formattedAvailability: this.getHtmlFormattedAvailability(newRawAvailability)
    });
    let calendarApi = this.calendarRef.current.getApi()
    calendarApi.setOption('timeZone', zone);
  }

  calendarRef = React.createRef()

  copyToClipboard = (e) => {
    // Flash the button green for a second
    this.setState({ flashClipboard: true }, () => {
      setTimeout(() => this.setState({ flashClipboard: false }), 1000)
    })

    let markdownString = this.state.markdownAvailability;
    let converter = new showdown.Converter();
    let htmlString = converter.makeHtml(markdownString);
    function listener(e) {
      // Copy both a plaintext (markdown) and html version to the clipboard.
      e.clipboardData.setData("text/plain", markdownString);
      e.clipboardData.setData("text/html", htmlString);
      e.preventDefault();
    }
    document.addEventListener("copy", listener);
    document.execCommand("copy");
    document.removeEventListener("copy", listener);
  }

  handleSelection = (info) => {
    // // millisecond value is correctly in America/New_York
    // console.log(info.date.valueOf())

    // // use the plugin for manipulation and formatting
    // let m = toMoment(calendar, info.date)
    // console.log(m.format()) // something like '2018-09-01T12:30:00-05:00'

    let calendarApi = this.calendarRef.current.getApi()
    calendarApi.unselect()
    let event = calendarApi.addEvent({
      title: 'Hold',
      start: info.start,
      end: info.end // a property! ** see important note below about 'end' **
      });

    info['calEvent'] = event;

    let selectedWindowsToBe = [...this.state.selectedWindows, info];
    let rawAvailability = this.getRawAvailability(selectedWindowsToBe);
    this.setState({
      selectedWindows: selectedWindowsToBe,
      rawAvailability: rawAvailability,
      markdownAvailability: this.getMarkdownFormattedAvailability(rawAvailability),
      formattedAvailability: this.getHtmlFormattedAvailability(rawAvailability)
    });
  }


  handleRemoveEvent = (id, e) => {
    // let calendarApi = this.calendarRef.current.getApi()
    this.state.selectedWindows[id].calEvent.remove();
    let tempSelectedWindows = this.state.selectedWindows;
    tempSelectedWindows.splice(id,1);

    let rawAvailability = this.getRawAvailability(tempSelectedWindows);
    this.setState({
      selectedWindows: tempSelectedWindows,
      rawAvailability: rawAvailability,
      markdownAvailability: this.getMarkdownFormattedAvailability(rawAvailability),
      formattedAvailability: this.getHtmlFormattedAvailability(rawAvailability)
    });
  }


  getMarkdownFormattedAvailability = (rawAvailability) => {
    // convert to markdown
    let windows = rawAvailability['windows'];
    let header = rawAvailability['header'];
    let markdownFormattedAvailability = `${header}`;
    windows.forEach(function(window, index){
      markdownFormattedAvailability = markdownFormattedAvailability + `
* ${window}`
    });
    return markdownFormattedAvailability;
  }

  getHtmlFormattedAvailability = (rawAvailability) => {
    let windows = rawAvailability['windows'];
    let header = rawAvailability['header'];

    // convert to react html
    let formattedAvailability = (windows.length == 0) ? "" :
      <div>
        <p>{header}</p>
        <List verticalAlign='middle' bulleted >
          {windows.map((value, index) => {
            return (
              <List.Item key={index}>
                <List.Content>
                  {value}
                </List.Content>
              </List.Item>
            )
          })}
        </List>
      </div>
    return formattedAvailability;
  }


  getRawAvailability = (selectedWindows, newTimezone='') => {
    const [{ currentTimezone }, dispatch] = this.context;

    let thisCurrentTimezone = (newTimezone === '') ? currentTimezone : newTimezone;

    let explodedSelectedWindows = [];
    for (var i = selectedWindows.length - 1; i >= 0; i--) {
      // Convert the raw events into the current timezone
      let start = moment(selectedWindows[i].start).tz(currentTimezone);
      let end = moment(selectedWindows[i].end).tz(currentTimezone);


      // create the window
      let s = (start.format('m') == '0') ? start.format('ha-') : start.format('h:ma-');
      let e = (end.format('m') == '0') ? end.format('ha') : end.format('h:ma');
      let window = s + e;
      if (window.includes('am') && window.includes('pm')) {
        // do nothing
      } else if (window.includes('am')) {
        // replace the first instance of am
        window = window.replace('am', '');
      } else {
        // replace the first instance of pm
        window = window.replace('pm', '');
      }
      window = window.replace(/m/g, '');

      explodedSelectedWindows.push({
        day: start.format('ddd'),
        date: start.format('M/D'),
        startRank: parseInt(start.format('k')+start.format('mm')),
        window: window
      });
    }


    let groupedWindows = groupBy(explodedSelectedWindows, "date");
    let formattedSelectedWindows = [];
    let sortedDates = Object.keys(groupedWindows).sort((a, b) => (moment(a, 'M/D').isAfter(moment(b,'M/D'))) ? 1 : -1);

    sortedDates.forEach(function(key,index) {
      groupedWindows[key] = groupedWindows[key].sort((a, b) => (a.startRank > b.startRank) ? 1 : -1);
      let formattedWindow = groupedWindows[key][0]['day'] + " " + groupedWindows[key][0]['date'] + " -- ";
      for (var i = 0; i < groupedWindows[key].length; i++) {
        let availableWindow = groupedWindows[key][i];
        formattedWindow = (i < groupedWindows[key].length-1) ? formattedWindow + availableWindow['window'] +
          ", " : formattedWindow + availableWindow['window'];
      }
      formattedSelectedWindows.push(formattedWindow);
    });

    let rawAvailability = {
      windows: formattedSelectedWindows,
      header: `All times in ${TIMEZONES[currentTimezone]['short']}:`
    };
    return rawAvailability;

  }

  handleClearSelections = (e) => {
    // Flash the button green for a second
    this.setState({ flashClearButton: true }, () => {
      setTimeout(() => this.setState({ flashClearButton: false }), 1000)
    })

    this.setState({
      selectedWindows: [],
      rawAvailability: {},
      markdownAvailability: "",
      formattedAvailability: "",
      rawHtmlFormattedAvailability: ""

    });
    this.state.selectedWindows.forEach((window, index) => {
      window.calEvent.remove();
    });
  }

  sendAccessRequest = () => {
    this.setState({FORM_ACCESSREQUEST_loading: true,
                   FORM_ACCESSREQUEST_successMessage: null,
                   FORM_ACCESSREQUEST_errorMessage: null});
    const [{ firebaseUser, firebaseUserIdToken}, dispatch] = this.context;
    const { FORM_ACCESSREQUEST_recipientEmail } = this.state;
    axios({
      method: 'post',
      url: `${photonConfig.functionsURL}accessRequest`,
      headers: { Authorization: `Bearer ${firebaseUserIdToken}` },
      data: {recipientEmail: FORM_ACCESSREQUEST_recipientEmail}
    })
    .then(result => {
      this.setState({FORM_ACCESSREQUEST_successMessage: `Access request sent successfully to ${FORM_ACCESSREQUEST_recipientEmail}!`,
                     FORM_ACCESSREQUEST_recipientEmail: '',
                     FORM_ACCESSREQUEST_loading: false});
    })
    .catch(error => {
      this.setState({FORM_ACCESSREQUEST_errorMessage: `${FORM_ACCESSREQUEST_recipientEmail} doesn't have a Photon account yet! Eventually you can invite new users, but only after Photon graduates out of beta. For now, just email the Photon team if you want this person added: `,
                     FORM_ACCESSREQUEST_loading: false});
    });
  }

  handleFormStateChange = (e, { name, value }) => this.setState({ [name]: value })

  calendarNext = () => this.calendarRef.current.getApi().next()
  calendarPrev = () => this.calendarRef.current.getApi().prev()
  calendarToday = () => this.calendarRef.current.getApi().today()
  calendarToggleWeekends = () => {
    let calendarApi = this.calendarRef.current.getApi()
    calendarApi.setOption('weekends', !calendarApi.getOption('weekends'));
  }


  render() {
    const [{ isLoading, firebaseUser, currentTimezone, calendarMap }, dispatch] = this.context;
    console.log('rendering calendar');
    const { FORM_ACCESSREQUEST_recipientEmail, FORM_ACCESSREQUEST_success } = this.state

    if (!firebaseUser) {
      return (
        <Redirect to={'/sign-in'}/>
      )
    }

    let visibleEvents = [];
    let calendars = [];
    Object.keys(calendarMap).forEach(calendarId => {
      let calendarItem = calendarMap[calendarId];
      if (calendarItem.visible) {
        visibleEvents = visibleEvents.concat(calendarItem.events)
      }
      calendars.push(calendarItem);
    });
    calendars = calendars.sort((a,b) => {return a.summary.localeCompare(b.summary) });
    let groupedCalendars = groupBy(calendars, "isOwner");
    console.log(groupedCalendars)

    return (
      <div>
        { isLoading &&
          <Dimmer active inverted  style={{backgroundColor:'white'}}>
            <span><Image size='small' circular src={require("../img/photonlogo_light_withmargin.svg")} /> </span>
            <p as='h4' style={{marginBottom:'3em', marginTop:'2em', color:'#7f8c8d'}}>Loading Photon </p>
            <SpinnerRomb color="#3498DB" size={68} speed={75} thickness={80} />
          </Dimmer>
        }

        <Nav
          isLoadingAccounts={this.state.isLoadingAccounts}
          accounts={this.state.accounts}
          addNewAccountWithAuthCode={this.addNewAccountWithAuthCode}
          getEventsForAccount={this.getEventsForAccount}
          handleRemoveAccount={this.handleRemoveAccount}

          calendarNext={this.calendarNext}
          calendarPrev={this.calendarPrev}
          calendarToday={this.calendarToday}
          calendarToggleWeekends={this.calendarToggleWeekends}
          />
        <Container fluid style={{ height: '100vh', paddingTop: '58px' }} >
          <Grid style={{ height: '100%'}}>
            <Grid.Column style={{flex: '0 0 400px', paddingRight: '0'}}>
              <Menu attached widths={2}>
                  <Menu.Item active={this.state.flashClearButton === true} disabled={this.state.formattedAvailability.length == ""} onClick={this.handleClearSelections} color={'red'}>
                    <Icon name='trash alternate outline' />
                    {this.state.flashClearButton === true ? (
                      <span>Cleared!</span>
                    ) : (
                      <span>Clear</span>
                    )}

                  </Menu.Item>
                  <Menu.Item active={this.state.flashClipboard === true} disabled={this.state.formattedAvailability.length == ""} color={'green'} onClick={(e) => this.copyToClipboard(e)}>
                    <Icon name='clipboard' />
                    {this.state.flashClipboard === true ? (
                      <span>Copied!</span>
                    ) : (
                      <span>Copy to clipboard</span>
                    )}
                  </Menu.Item>
              </Menu>
              {this.state.formattedAvailability.length == "" ? (
                <Segment attached placeholder >
                  <Header icon>
                    <Icon name='arrow right' />
                    Add your availability by clicking on the calendar.
                  </Header>
                </Segment>
              ) : (
                <>
                  <Message attached warning clearing style={{minHeight: '150px'}} >
                    {/*<Button size='mini' icon='clipboard' content='Copy to clipboard' floated='right' onClick={(e) => this.copyToClipboard(e)} />*/}
                    <div id="availability" >
                      {this.getHtmlFormattedAvailability(this.state.rawAvailability)}
                    </div>
                  </Message>
                  <Segment attached secondary style={{minHeight: '102px'}}>
                    <pre style={{margin: '0'}}>
                    <List verticalAlign='middle' size='tiny'>
                      {this.state.selectedWindows.map((value, index) => {
                        return (
                          <List.Item key={index}>
                            <List.Content>
                               <Icon onClick={(e) => this.handleRemoveEvent(index, e)} name='close' link color='red' />
                               {moment(value.start).tz(currentTimezone).format("dddd, h:mm a - ") + moment(value.end).tz(currentTimezone).format("h:mm a z") }
                            </List.Content>
                          </List.Item>
                        )
                      })}
                    </List>
                    </pre>
                  </Segment>
                </>
              )}
              <Segment attached>

                <>
                { groupedCalendars[true] &&
                  <List verticalAlign='middle'>
                    <List.Item>
                      {/*<List.Content floated='right'><Loader active={isLoading} inline size='tiny'></Loader></List.Content>*/}
                      <List.Header>My Calendars</List.Header>

                    </List.Item>
                  </List>
                }
                { groupedCalendars[true] &&
                  groupedCalendars[true].map((value, index) => {
                    return (
                      <Form.Field key={value.id}>
                        <Checkbox onChange={() => dispatch({
                          type: 'toggleCalendarVisibility',
                          calendarId: value.id
                        })}
                        checked={value.visible}
                        label={value.summary} />
                      </Form.Field>
                    )
                  })
                }
                </>

                <>
                { groupedCalendars[false] &&
                  <List verticalAlign='middle'>
                    <List.Item>
                      <List.Content floated='right'><Loader active={isLoading} inline size='tiny'></Loader></List.Content>
                      <List.Header>Other Calendars</List.Header>

                    </List.Item>
                  </List>
                }
                { groupedCalendars[false] &&
                  groupedCalendars[false].map((value, index) => {
                    return (
                      <Form.Field key={value.id}>
                        <Checkbox onChange={() => dispatch({
                          type: 'toggleCalendarVisibility',
                          calendarId: value.id
                        })}
                        checked={value.visible}
                        label={value.summary} />
                      </Form.Field>
                    )
                  })
                }
                </>

              </Segment>
              <Segment attached='bottom'>
                <Form onSubmit={this.sendAccessRequest}
                      loading={this.state.FORM_ACCESSREQUEST_loading}
                      success={this.state.FORM_ACCESSREQUEST_successMessage != null}
                      error={this.state.FORM_ACCESSREQUEST_errorMessage != null}>
                    <Form.Field>
                      <label>Request access to a calendar</label>
                      <input 
                        placeholder='Email'
                        value={FORM_ACCESSREQUEST_recipientEmail}
                        name='FORM_ACCESSREQUEST_recipientEmail'
                        onChange={this.handleFormStateChange}
                      />
                    </Form.Field>                    
                    <Form.Button content='Send'/>
                  <Message
                    success
                    content={this.state.FORM_ACCESSREQUEST_successMessage}
                  />
                  <Message error>
                    <p>{this.state.FORM_ACCESSREQUEST_errorMessage} <a href='mailto:invites@usephoton.com'>invites@usephoton.com</a></p>
                  </Message>
                </Form>
              </Segment>
            </Grid.Column>
            <Grid.Column style={{flex: '1', height: '100%', paddingLeft: '0'}}>
              <FullCalendar
                events = {visibleEvents}
                plugins = {[ timeGridPlugin, interactionPlugin, momentTimezonePlugin ]}
                timeZone = {currentTimezone}
                ref = { this.calendarRef }
                height = 'parent'
                nowIndicator = {true}
                eventTimeFormat = {{
                  hour: 'numeric',
                  minute: '2-digit',
                  meridiem: true,
                  omitZeroMinute: true
                }}
                eventColor = 'rgb(3, 155, 229)'
                eventBorderColor = 'rgb(3, 155, 229)'
                eventTextColor = 'rgb(255, 255, 255)'
                defaultView = "timeGridWeek"
                selectable = "true"
                eventClick = {this.handleEventClick}
                select = {this.handleSelection}
                dateClick = {this.handleEventClick}
                weekends = {false}
                header = {false}/>
            </Grid.Column>
          </Grid>
        </Container>
      </div>
    );
  }
}


export default Calendar;


